import { Button, Table } from "@arco-design/web-react";
import React, { useEffect, useMemo, useState } from "react";

function DocumentComparisonResult({ resultsData, file1, file2 }) {
  const [activePdf, setActivePdf] = useState(null); // To store the active PDF to display in the iframe

  // Original dynamic key to access data
  const dataKey = useMemo(() => {
    const keys = Object.keys(resultsData || {});
    return (
      keys.find((key) => key !== "HHLI" && key !== "Matching parameters") ||
      "Employee_letter"
    );
  }, [resultsData]);

  // Display key with underscores replaced for UI
  const displayKey = useMemo(() => dataKey.replace(/_/g, " "), [dataKey]);

  const handlePdfView = (file) => {
    if (file) {
      setActivePdf(URL.createObjectURL(file)); // Create a URL for the selected file
    } else {
      setActivePdf(null); // Clear the iframe if no file is selected
    }
  };
  const columns = useMemo(
    () => [
      { title: "", dataIndex: "parameter" },
      { title: "HHLI FORM", dataIndex: "doc1" },
      { title: displayKey, dataIndex: "doc2" }, // Display dynamic key without underscores
      { title: "Comparison", dataIndex: "comparison" },
    ],
    [displayKey]
  );

  const data = useMemo(
    () => [
      {
        key: "1",
        parameter: "Name",
        doc1: resultsData?.HHLI?.Name || "N/A",
        doc2: resultsData?.[dataKey]?.["Employee Name"] || "N/A", // Use the original key for accessing data
        comparison: (
          <span
            className={`badge ${
              resultsData?.["Matching parameters"]?.name_match === "Matching"
                ? "badge_success_soft"
                : "badge_danger_soft"
            } font_12`}
          >
            {resultsData?.["Matching parameters"]?.name_match || "N/A"}
          </span>
        ),
      },
      {
        key: "2",
        parameter: "Income",
        doc1: resultsData?.HHLI?.["total income"] || "N/A",
        doc2: resultsData?.[dataKey]?.["Gross Income"] || "N/A", // Use the original key for accessing data
        comparison: (
          <span
            className={`badge ${
              resultsData?.["Matching parameters"]?.income_match === "Matching"
                ? "badge_success_soft"
                : "badge_danger_soft"
            } font_12`}
          >
            {resultsData?.["Matching parameters"]?.income_match || "N/A"}
          </span>
        ),
      },
      {
        key: "3",
        parameter: "Pay Schedule",
        doc1: resultsData?.HHLI?.["pay schedule"] || "N/A",
        doc2: resultsData?.[dataKey]?.["Pay Schedule"] || "N/A", // Use the original key for accessing data
        comparison: (
          <span
            className={`badge ${
              resultsData?.["Matching parameters"]?.schedule_match ===
              "Matching"
                ? "badge_success_soft"
                : "badge_danger_soft"
            } font_12`}
          >
            {resultsData?.["Matching parameters"]?.schedule_match || "N/A"}
          </span>
        ),
      },
      {
        key: "4",
        parameter: "Family Size",
        doc1: resultsData?.HHLI?.["family_size"] || "",
        doc2: "",
        comparison: "",
      },
    ],
    [resultsData, dataKey]
  );

  // Effect to set the default active PDF to file1's object URL
  useEffect(() => {
    if (file1) {
      setActivePdf(URL.createObjectURL(file1)); // Set default to file1
    }
  }, [file1]);

  return (
    <div className="p-3 visible_Section">
      <div className="tab-switcher d-flex gap-2">
        <Button
          shape="round"
          type="primary"
          onClick={() => handlePdfView(file1)}
        >
          View HHLI FORM
        </Button>
        <Button
          shape="round"
          type="primary"
          onClick={() => handlePdfView(file2)}
        >
          VIEW {displayKey}
        </Button>
      </div>
      <div className="row mt-4">
        <div className="bd_dotted_0 bd_master2 col-12 col-md-6">
          <iframe
            title="Document Preview"
            src={activePdf} // Set the src to the active PDF
            style={{ width: "100%", height: "500px", border: "none" }}
          />
        </div>
        <div className="col-md-6">
        <h3 className="font_18 font_600 mb-3 text-center">Comparison Result</h3>
          <div className="overflow-auto scrollbar1">
            <Table
              columns={columns}
              data={data}
              pagination={false}
              bordered
              className={"comparison__table_props"}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DocumentComparisonResult;
